import { render, staticRenderFns } from "./IArchive.vue?vue&type=template&id=89e37bb4&"
import script from "./IArchive.vue?vue&type=script&lang=ts&"
export * from "./IArchive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports